import React from 'react'
import { Updater, any, async, fromJSX, nothing } from 'widgets-for-react'
import { StandardLocalWidget } from 'widgets-for-react'
import { ContactUsLayout } from './contactUs.layout'
import { ContactUsState, contactUsUpdaters } from './contactUs.state'

export const contactUsWidget: StandardLocalWidget<ContactUsState> = (currentState) =>
  currentState.submission === undefined || currentState.submission.kind !== 'loaded'
    ? any([
        currentState.validator.widget().map(contactUsUpdaters.validation),
        fromJSX((setState) => <ContactUsLayout.PageHeader />),
        fromJSX<Updater<ContactUsState>>((setState) => (
          <ContactUsLayout.Form setState={setState} currentState={currentState} />
        )).wrapHTML(ContactUsLayout.Wrapper),
        currentState.submission != undefined
          ? async(currentState.submission).map((u) => contactUsUpdaters.submission(u))
          : nothing()
      ])
    : fromJSX((_) => <ContactUsLayout.ThankYou />)
